/* Atlas run club (ported from ac-cat-v2 runs-board.js). */
/* Atlas runs board: city filter, upcoming/past, list/calendar views, next-run countdown, .ics download.
   Server renders the default state (all cities, upcoming, list). This script re-renders from the embedded JSON
   whenever the state changes, or on load when the visitor's local date differs from the server's. */
(function () {
  'use strict';

  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var INK = '#141413';

  var ICON = {
    calendar: function (sz, sw) { return svg(sz, sw, '<rect x="3" y="4" width="18" height="18" rx="2"></rect><path d="M16 2v4M8 2v4M3 10h18"></path>'); },
    arrow: function (sz, sw) { return svg(sz, sw, '<path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>'); },
    down: function (sz, sw) { return svg(sz, sw, '<path d="m6 9 6 6 6-6"></path>'); },
    prev: function (sz, sw) { return svg(sz, sw, '<path d="m15 18-6-6 6-6"></path>'); },
    next: function (sz, sw) { return svg(sz, sw, '<path d="m9 18 6-6-6-6"></path>'); }
  };
  function svg(sz, sw, inner) {
    return '<svg width="' + sz + '" height="' + sz + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round" style="display:block;flex:none" aria-hidden="true" focusable="false">' + inner + '</svg>';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function P(d) { var a = d.split('-').map(Number); return new Date(a[0], a[1] - 1, a[2]); }
  function localToday() { var n = new Date(); return n.getFullYear() + '-' + pad(n.getMonth() + 1) + '-' + pad(n.getDate()); }
  function cmp(a, b) { return a < b ? -1 : a > b ? 1 : 0; }

  function Board(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-runs-json]').textContent); } catch (e) { return; }
    var L = data.labels || {};
    var series = (data.series || []).map(function (x) { x.dates = (x.dates || []).slice().sort(); x.meta = x.meta || []; return x; });
    var cityColor = {};
    (data.cities || []).forEach(function (c) { cityColor[c.id] = c.c || INK; });
    function col(c) { return cityColor[c] || INK; }

    var serverToday = root.getAttribute('data-today');
    var today = localToday();
    var st = { city: 'All', when: 'up', view: 'list', open: null, month: null, day: null };

    var elNx = root.querySelector('[data-runs-nx]');
    var elChips = root.querySelector('[data-runs-chips]');
    var elList = root.querySelector('[data-runs-list]');
    var elCal = root.querySelector('[data-runs-cal]');
    if (!elList) return;

    // flatten series into dated occurrences (stable by series order, like the prototype's flatMap + sort)
    var evs = [];
    series.forEach(function (s) { s.dates.forEach(function (d) { evs.push({ s: s, d: d }); }); });
    evs = evs.map(function (e, i) { e.i = i; return e; }).sort(function (a, b) { return cmp(a.d, b.d) || a.i - b.i; });

    function inCity(e) { return st.city === 'All' || e.s.city === st.city; }
    function inWhen(e) { return st.when === 'up' ? e.d >= today : e.d < today; }
    function plural(n) { return n + ' ' + (n === 1 ? L.one : L.many); }

    function icsDownload(id, d) {
      var s = series.filter(function (x) { return x.id === id; })[0];
      if (!s) return;
      var dt = d.replace(/-/g, ''), prefix = data.prefix || '';
      var body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//' + data.brand + '//' + prefix + '//EN', 'BEGIN:VEVENT',
        'UID:' + s.id + '-' + dt + '@' + location.hostname, 'DTSTART;VALUE=DATE:' + dt,
        'SUMMARY:' + prefix + ' ' + s.city + ' // ' + s.title,
        'DESCRIPTION:' + (s.desc || '').replace(/[,;]/g, ' ').replace(/\s*[\r\n]+\s*/g, ' '),
        'LOCATION:' + s.city, 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar' }));
      a.download = (prefix || 'run').toLowerCase() + '-' + dt + '.ics';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
    }

    /* ---------- Next run ---------- */
    function nextHTML(e) {
      var p = P(e.d), diff = Math.round((p - P(today)) / 864e5);
      var when = diff === 0 ? L.today : diff === 1 ? L.tomorrow : String(L.inDays || '').replace('{n}', diff);
      var metas = '<span class="runs-nx__meta"><span class="runs-dot" style="background:' + esc(col(e.s.city)) + '"></span>' + esc(e.s.city) + '</span>' +
        e.s.meta.slice(0, 4).map(function (t) { return '<span class="runs-nx__meta">' + esc(t) + '</span>'; }).join('');
      return '<div class="runs-nx__l"><div class="runs-nx__tile"><span class="runs-nx__tm">' + MON[p.getMonth()] + '</span><span class="runs-nx__td">' + p.getDate() + '</span><span class="runs-nx__tm">' + WD[p.getDay()] + '</span></div>' +
        '<div class="runs-nx__info"><span class="runs-nx__kicker"><span class="runs-nx__tag">' + esc(L.next) + '</span>' + esc(when) + '</span>' +
        '<span class="runs-nx__title">' + esc(e.s.title) + '</span><span class="runs-nx__metas">' + metas + '</span></div></div>' +
        '<div class="runs-nx__btns"><button type="button" class="runs-nx__add" data-ics="' + esc(e.s.id + '|' + e.d) + '">' + ICON.calendar(16, 1.8) + esc(L.add) + '</button>' +
        (e.s.link ? '<a class="runs-nx__det" href="' + esc(e.s.link) + '" target="_blank" rel="noopener">' + esc(L.details) + ICON.arrow(16, 2) + '</a>' : '') + '</div>';
    }
    function renderNext() {
      if (!elNx) return;
      var e = evs.filter(function (x) { return inCity(x) && x.d >= today; })[0];
      if (e && st.when === 'up') { elNx.innerHTML = nextHTML(e); elNx.hidden = false; }
      else { elNx.hidden = true; elNx.innerHTML = ''; }
    }

    /* ---------- Chips / tabs ---------- */
    function renderControls() {
      if (elChips) {
        Array.prototype.forEach.call(elChips.querySelectorAll('[data-city]'), function (b) {
          var c = b.getAttribute('data-city'), on = c === st.city;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var n = evs.filter(function (e) { return (c === 'All' || e.s.city === c) && inWhen(e); }).length;
          var el = b.querySelector('.runs-chip__n'); if (el) el.textContent = String(n);
        });
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-when]'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-when') === st.when); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-view]'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-view') === st.view); });
    }

    /* ---------- List ---------- */
    function itemHTML(g, k) {
      var up = st.when === 'up', open = st.open === k;
      var f = P(g.ds[0]), nextD = g.ds.filter(function (d) { return d >= today; })[0] || g.ds[0];
      var many = g.ds.length > 1;
      var dates = many ? '<span class="runs-item__dates">' + g.ds.map(function (d) {
        var p = P(d); return '<span class="runs-date' + (d === nextD && up ? ' is-next' : '') + '">' + WD[p.getDay()] + ' ' + p.getDate() + '</span>';
      }).join('') + '</span>' : '';
      var metaList = (g.s.partner ? [L['with'] + ' ' + g.s.partner] : []).concat(g.s.meta);
      var metas = metaList.length ? '<div class="runs-metas">' + metaList.map(function (t) { return '<span class="runs-meta">' + esc(t) + '</span>'; }).join('') + '</div>' : '';
      return '<article class="runs-item' + (open ? ' is-open' : '') + '" data-runs-item>' +
        '<button type="button" class="runs-item__btn" data-toggle="' + esc(k) + '" aria-expanded="' + open + '" aria-controls="runs-p-' + esc(k) + '">' +
        '<span class="runs-item__tile' + (up ? ' is-up' : '') + '"><span class="runs-item__day">' + f.getDate() + '</span><span class="runs-item__wd">' + (many ? g.ds.length + '×' : WD[f.getDay()]) + '</span></span>' +
        '<span class="runs-item__body"><span class="runs-item__top"><span class="runs-item__city"><span class="runs-dot" style="background:' + esc(col(g.s.city)) + '"></span>' + esc(g.s.city) + '</span>' +
        (g.s.dates.length > 2 ? '<span>' + esc(L.freq) + '</span>' : '') + '</span><span class="runs-item__title">' + esc(g.s.title) + '</span>' + dates + '</span>' +
        '<span class="runs-item__chev">' + ICON.down(18, 2) + '</span></button>' +
        '<div class="runs-item__panel" id="runs-p-' + esc(k) + '"' + (open ? '' : ' hidden') + '><p class="runs-item__desc">' + esc(g.s.desc) + '</p>' + metas +
        '<div class="runs-actions">' + (up ? '<button type="button" class="runs-btn runs-btn--dark" data-ics="' + esc(g.s.id + '|' + nextD) + '">' + ICON.calendar(16, 1.8) + esc(L.add) + '</button>' : '') +
        (g.s.link ? '<a class="runs-btn runs-btn--light" href="' + esc(g.s.link) + '" target="_blank" rel="noopener">' + esc(L.details) + ICON.arrow(16, 2) + '</a>' : '') +
        '</div></div></article>';
    }
    function listHTML() {
      var vis = evs.filter(function (e) { return inCity(e) && inWhen(e); });
      var byMonth = {};
      vis.forEach(function (e) { var k = e.d.slice(0, 7); (byMonth[k] = byMonth[k] || []).push(e); });
      var keys = Object.keys(byMonth).sort(); if (st.when === 'past') keys.reverse();
      var html = keys.map(function (k) {
        var list = byMonth[k], groups = [];
        list.forEach(function (e) {
          var g = groups.filter(function (x) { return x.s.id === e.s.id; })[0];
          if (!g) { g = { s: e.s, ds: [] }; groups.push(g); }
          g.ds.push(e.d);
        });
        if (st.when === 'past') groups.reverse();
        var m = +k.split('-')[1];
        return '<section class="runs-month"><div class="runs-month__head"><h2 class="runs-month__title">' + MONL[m - 1] + ' ' + k.slice(0, 4) + '</h2><span class="runs-month__count">' + plural(list.length) + '</span></div>' +
          groups.map(function (g) { return itemHTML(g, g.s.id + k); }).join('') + '</section>';
      }).join('');
      if (!keys.length) html = '<div class="runs-empty"><span class="runs-empty__t">' + esc(L.emptyTitle) + '</span><span class="runs-empty__x">' + esc(L.emptyText) + '</span></div>';
      return html;
    }

    /* ---------- Calendar ---------- */
    function calHTML() {
      var vis = evs.filter(function (e) { return inCity(e) && inWhen(e); });
      var cityEvs = evs.filter(inCity);
      var firstUp = (vis[0] || evs.filter(function (e) { return e.d >= today; })[0] || evs[0] || { d: today }).d;
      var cm = st.month || firstUp.slice(0, 7), a = cm.split('-').map(Number), cy = a[0], cmo = a[1];
      var first = new Date(cy, cmo - 1, 1), off = (first.getDay() + 6) % 7, dim = new Date(cy, cmo, 0).getDate();
      var selDay = st.day && st.day.indexOf(cm) === 0 ? st.day :
        ((cityEvs.filter(function (e) { return e.d.indexOf(cm) === 0 && e.d >= today; })[0] || cityEvs.filter(function (e) { return e.d.indexOf(cm) === 0; })[0] || {}).d || cm + '-01');
      var cells = '', i, d;
      for (i = 0; i < off; i++) cells += '<span class="runs-cell" aria-hidden="true"></span>';
      for (d = 1; d <= dim; d++) {
        var ds = cm + '-' + pad(d), de = cityEvs.filter(function (e) { return e.d === ds; }), on = ds === selDay;
        var seen = {}, dots = '';
        de.forEach(function (e) { if (!seen[e.s.city] && Object.keys(seen).length < 3) { seen[e.s.city] = 1; dots += '<span style="background:' + (on ? '#FFFFFF' : esc(col(e.s.city))) + '"></span>'; } });
        cells += '<button type="button" class="runs-cell' + (de.length ? ' has-ev' : '') + (ds === today && !on ? ' is-today' : '') + (ds < today && !on ? ' is-past' : '') + (on ? ' is-sel' : '') + '"' + (de.length ? ' data-day="' + ds + '"' : '') + '>' + d + '<span class="runs-cell__dots">' + dots + '</span></button>';
      }
      var sd = P(selDay), dayList = cityEvs.filter(function (e) { return e.d === selDay; });
      var dayCards = dayList.map(function (e) {
        return '<div class="runs-daycard"><span class="runs-daycard__city"><span class="runs-dot" style="background:' + esc(col(e.s.city)) + '"></span>' + esc(e.s.city) + '</span>' +
          '<span class="runs-daycard__title">' + esc(e.s.title) + '</span><span class="runs-daycard__desc">' + esc(e.s.desc) + '</span><div class="runs-actions">' +
          (e.d >= today ? '<button type="button" class="runs-btn runs-btn--dark" data-ics="' + esc(e.s.id + '|' + e.d) + '">' + ICON.calendar(16, 1.8) + esc(L.addShort) + '</button>' : '') +
          (e.s.link ? '<a class="runs-btn runs-btn--light" href="' + esc(e.s.link) + '" target="_blank" rel="noopener">' + esc(L.details) + ICON.arrow(16, 2) + '</a>' : '') + '</div></div>';
      }).join('');
      var head = ['M', 'T', 'W', 'T', 'F', 'S', 'S'].map(function (t) { return '<span class="runs-calhead">' + t + '</span>'; }).join('');
      return '<div class="runs-calcard"><div class="runs-calcard__head"><span class="runs-calcard__label">' + MONL[cmo - 1] + ' ' + cy + '</span><div class="runs-calcard__nav">' +
        '<button type="button" class="runs-calcard__nb" data-shift="-1" aria-label="' + esc(L.prevMonth) + '">' + ICON.prev(18, 2) + '</button>' +
        '<button type="button" class="runs-calcard__nb" data-shift="1" aria-label="' + esc(L.nextMonth) + '">' + ICON.next(18, 2) + '</button></div></div>' +
        '<div class="runs-calgrid">' + head + cells + '</div></div>' +
        '<div class="runs-day"><span class="runs-day__label">' + WD[sd.getDay()] + ' ' + sd.getDate() + ' ' + MON[sd.getMonth()] + ' · ' + plural(dayList.length) + '</span>' + dayCards +
        (dayList.length ? '' : '<div class="runs-day__empty">' + esc(L.dayEmpty) + '</div>') + '</div>';
    }

    function render() {
      renderControls();
      renderNext();
      var cal = st.view === 'cal';
      elList.hidden = cal;
      if (elCal) elCal.hidden = !cal;
      if (cal) { if (elCal) elCal.innerHTML = calHTML(); }
      else elList.innerHTML = listHTML();
    }

    /* ---------- Events ---------- */
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      var v;
      if ((v = t.getAttribute('data-ics'))) { var p = v.split('|'); icsDownload(p[0], p[1]); return; }
      if (t.hasAttribute('data-city')) { st.city = t.getAttribute('data-city'); st.open = null; st.day = null; render(); return; }
      if (t.hasAttribute('data-when')) { st.when = t.getAttribute('data-when'); st.open = null; render(); return; }
      if (t.hasAttribute('data-view')) { st.view = t.getAttribute('data-view'); render(); return; }
      if (t.hasAttribute('data-toggle')) {
        var k = t.getAttribute('data-toggle'), isOpen = st.open === k;
        Array.prototype.forEach.call(elList.querySelectorAll('[data-runs-item]'), function (a) {
          var b = a.querySelector('[data-toggle]'), on = !isOpen && b === t;
          a.classList.toggle('is-open', on);
          b.setAttribute('aria-expanded', on ? 'true' : 'false');
          a.querySelector('.runs-item__panel').hidden = !on;
        });
        st.open = isOpen ? null : k;
        return;
      }
      if (t.hasAttribute('data-day')) { st.day = t.getAttribute('data-day'); render(); return; }
      if (t.hasAttribute('data-shift')) {
        var cm = st.month || (function () {
          var vis = evs.filter(function (e) { return inCity(e) && inWhen(e); });
          return (vis[0] || evs.filter(function (e) { return e.d >= today; })[0] || evs[0] || { d: today }).d.slice(0, 7);
        })();
        var a = cm.split('-').map(Number), d = new Date(a[0], a[1] - 1 + Number(t.getAttribute('data-shift')), 1);
        st.month = d.getFullYear() + '-' + pad(d.getMonth() + 1); st.day = null; render();
      }
    });

    // Server rendered the default state for its own date; refresh if the visitor's day differs.
    if (today !== serverToday) render();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-runs-board]'), function (r) {
      if (r.__runsInit) return; r.__runsInit = true; Board(r);
    });
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
